export type FileType = 'directory' | 'file' | 'email';

export enum ContentType {
    ImageJpeg = 'image/jpeg',
    ImagePng = 'image/png',
    VideoMp4 = 'video/mp4',
    ApplicationJson = 'application/json',
    ApplicationPdf = 'application/pdf',
    TextMarkdown = 'text/markdown',
    TextPlain = 'text/plain',
}

export type ServerFile = {
    fileId?: number; // webdav search results don't include a fileid prop
    name: string;
    path: string;
    parentPath: string;
    type: FileType;
    etag: string;
    lastmod: string;
    contenttype?: ContentType | string;
    contentlength: number;
    selected: boolean;
    shared: boolean;
};

export type RenameFileData = {
    initialPath: string;
    newFilename: string;
};

export type CreateFolderData = {
    path: string;
    folderName: string;
};

export type FileItem = {
    id?: string; // ? exists in some places but not others
    name: string;
    type: FileType;
    contenttype: string;
    content?: ArrayBuffer; // unset for chunked uploads (readableContent then)
    readableContent?: File | Blob;
    parentPath?: string; // exists in some places but not others
    lastmod?: Date; // exists in some places but not others
    path?: string; // exists in some places but not others
    selected: boolean; // does not seem to be used anywhere
    contentlength?: number; // exists in some places but not others
};

// what flows through filesToUpload and form `files`: local picks before
// upload, the ServerFile the upload returned afterwards
export type UploadFile = FileItem | ServerFile;

export const isServerFile = (file: UploadFile): file is ServerFile =>
    'etag' in file;

export const isLocalFile = (file: UploadFile): file is FileItem =>
    !isServerFile(file);
